import { createSlice } from '@reduxjs/toolkit';
import { PRICE } from '../../constants/pricing';

const pricingSlice = createSlice({
  name: 'pricing',
  initialState: PRICE,
  reducers: {},
});
 
export default pricingSlice.reducer;
